import { render, staticRenderFns } from "./TpFooter.vue?vue&type=template&id=86345c88&scoped=true&"
var script = {}
import style0 from "./TpFooter.vue?vue&type=style&index=0&id=86345c88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86345c88",
  null
  
)

export default component.exports